import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Rnd } from 'react-rnd';

interface Props {
  /** このダイアログが閉じられる際に呼ばれる関数。 */
  onClose?: () => void | undefined;
  /** このダイアログの内容。 */
  children: React.ReactNode;

  /** このダイアログのヘッダーに表示する要素。 */
  headerContents?: React.ReactNode | undefined;
}

/**
 * 構造ツリーウィンドウ。
 */
function SectionDataTreeWindow({ onClose, children, headerContents }: Props) {
  const [position, setPosition] = useState({
    x:
      // eslint-disable-next-line no-nested-ternary
      Number(localStorage.getItem('sectionDataTreeWindowX') ?? 100) + window.scrollX < 0
        ? 100 + window.scrollX
        : Number(localStorage.getItem('sectionDataTreeWindowX') ?? 100) + window.scrollX > window.innerWidth
        ? 100 + window.scrollX
        : Number(localStorage.getItem('sectionDataTreeWindowX') ?? 100) + window.scrollX,
    y:
      // eslint-disable-next-line no-nested-ternary
      Number(localStorage.getItem('sectionDataTreeWindowY') ?? 100) + window.scrollY < 0
        ? 100 + window.scrollY
        : Number(localStorage.getItem('sectionDataTreeWindowY') ?? 100) + window.scrollY > window.innerHeight
        ? 100 + window.scrollY
        : Number(localStorage.getItem('sectionDataTreeWindowY') ?? 100) + window.scrollY,
  });
  const [size, setSize] = useState({
    width: Number(localStorage.getItem('sectionDataTreeWindowWidth') ?? 400),
    height: Number(localStorage.getItem('sectionDataTreeWindowHeight') ?? 400),
  });

  /**
   * ウィンドウの位置を調整する（初回のみ）。
   */
  useEffect(() => {
    const { scrollX, scrollY, innerWidth, innerHeight } = window;

    let { x, y } = position;

    if (x < scrollX) {
      x = scrollX + 100;
    }
    if (y < scrollY) {
      y = scrollY + 100;
    }
    if (x + size.width > scrollX + innerWidth) {
      x = scrollX + innerWidth - size.width - 100;
    }
    if (y + size.height > scrollY + innerHeight) {
      y = scrollY + innerHeight - size.height - 100;
    }

    if (position.x !== x || position.y !== y) {
      setPosition({
        x,
        y,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** × ボタン押下時に実行される関数。prop で指定されていなければ、モーダルを閉じる動作のみ行う。 */
  const onCloseFunction =
    typeof onClose === 'function'
      ? onClose
      : () => {
          // empty
        };

  return ReactDOM.createPortal(
    <Rnd
      default={{
        x: position.x,
        y: position.y,
        width: size.width,
        height: size.height,
      }}
      className="section-data-tree-window"
      style={{
        position: 'fixed',
      }}
      onDragStop={(e, data) => {
        localStorage.setItem('sectionDataTreeWindowX', String(data.x));
        localStorage.setItem('sectionDataTreeWindowY', String(data.y));

        setPosition({
          x: data.x,
          y: data.y,
        });
      }}
      onResizeStop={(e, direction, ref) => {
        localStorage.setItem('sectionDataTreeWindowWidth', String(ref.offsetWidth));
        localStorage.setItem('sectionDataTreeWindowHeight', String(ref.offsetHeight > 1000 ? 1000 : ref.offsetHeight));

        setSize({
          width: ref.offsetWidth,
          height: ref.offsetHeight > 1000 ? 1000 : ref.offsetHeight,
        });
      }}
      dragHandleClassName="section-data-tree-window-header"
    >
      {/* ヘッダー。 */}
      <div
        style={{
          cursor: 'move',
          display: 'flex',
          justifyContent: headerContents ? 'space-between' : 'flex-end',
          borderBottom: '1px solid lightgray',
        }}
        className="section-data-tree-window-header"
        onDoubleClick={() => {
          localStorage.removeItem('sectionDataTreeWindowX');
          localStorage.removeItem('sectionDataTreeWindowY');
          localStorage.removeItem('sectionDataTreeWindowWidth');
          localStorage.removeItem('sectionDataTreeWindowHeight');
        }}
      >
        {/* prop で渡されてきた、ヘッダーに表示する要素。 */}
        {headerContents}
        {/* 閉じるボタン。 */}
        <button
          type="button"
          onClick={onCloseFunction}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            width: '20px',
            height: '20px',
          }}
        >
          ×
        </button>
      </div>
      {children}
    </Rnd>,
    document.body
  );
}

SectionDataTreeWindow.defaultProps = {
  onClose: undefined,
  headerContents: undefined,
};

export default SectionDataTreeWindow;
